import { GetApiResponseByUrl } from '@crossbeam/openapi';

export const FAVORITE_TYPES = {
  PARTNER: 'partner',
} as const;
export type FavoriteType = (typeof FAVORITE_TYPES)[keyof typeof FAVORITE_TYPES];

export type UserFavorite = GetApiResponseByUrl<'/v0.1/users/favorites'>[number];
